"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconStudentSmall = function IconStudentSmall(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m2 10 3 1.732v4.153S8.134 19.5 12 19.5s7-3.615 7-3.615v-4.153l1-.577v5.979a1 1 0 1 0 1 0v-6.557L22 10 12 4.227zm5 5.068v-2.181l5 2.886 5-2.886v2.181c-.298.281-.712.64-1.212.996C14.67 16.862 13.332 17.5 12 17.5s-2.67-.638-3.788-1.436c-.5-.356-.914-.715-1.212-.996M6 10l6 3.464L18 10l-6-3.464z",
    clipRule: "evenodd"
  })));
};

export { IconStudentSmall, IconStudentSmall as default };
